/**
 * @file Sums the amounts an investment allocated to a given project tier, as a currency string.
 */
import { getFormattedDecimalValue, getCurrencyValue } from "@components/Amount";

import type { Investment } from "../types";

const INITIAL_AMOUNT = 0;

/**
 * Sums the amounts of an investment's allocations to the given project tier and formats the total as currency.
 */
const getInvestmentAmountForProjectTier = (tierId: string, investment: Pick<Investment, "investments">): string => {
  const { investments } = investment;

  const amountValue = investments
    .filter(({ projectTierId }) => projectTierId === tierId)
    .map(({ amount }) => amount)
    .reduce((total, amount) => getFormattedDecimalValue(total, amount, "plus"), INITIAL_AMOUNT);

  const currencyValue = getCurrencyValue(amountValue);

  return currencyValue;
};

export default getInvestmentAmountForProjectTier;
